import {
	EARLY_FREEDOM_EXAMPLE_RENT,
	EARLY_FREEDOM_TARGET_FALLBACK,
} from "web_myplann/Inspiration/EarlyFreedom/constants";
import { computeEarlyFreedomContext } from "web_myplann/Inspiration/EarlyFreedom/Utils/earlyFreedomMath";

export const getEarlyFreedomExample = () => {
	const example = computeEarlyFreedomContext({
		targetExpenses: EARLY_FREEDOM_TARGET_FALLBACK,
		rentNet: EARLY_FREEDOM_EXAMPLE_RENT,
	});

	return {
		spend: example.targetExpenses,
		rent: example.passiveToday,
		gap: example.gap,
		capital: example.targetCapital,
	};
};
